import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { client } from "../client/index"

export const getTariff = createAsyncThunk(
  'mainPage/getTariff',
  async (_, thunkAPI) => {
    const response = await client.get("/subscribers/tariff");
    return response.data;
  }
);

export const getBrand = createAsyncThunk(
  'mainPage/getBrand',
  async () => {
    const response = await client.get("/subscribers/brand");
    return response.data;
  }
);

const mainPageSlice = createSlice({
  name: "mainPageSlice",
  initialState: {
    count: 147,
    loading: true,
    status: '',
    error: null,
    isAulet: null,
    brand: null,
  },
  reducers: {},
  extraReducers:
    (builder) => {
      builder
        .addCase(getTariff.pending, (state) => {
          state.status = 'loading';
          state.loading = true;
        })
        .addCase(getTariff.fulfilled, (state, action) => {
          state.status = 'succeeded';
          state.isAulet = action.payload;
          if (action.payload === true) {
            state.loading = false;
          }
        })
        .addCase(getTariff.rejected, (state, action) => {
          state.status = 'failed';
          state.error = action.error.message;
        });

      builder
        .addCase(getBrand.pending, (state) => {
          state.status = 'loading';
          state.loading = true;
        })
        .addCase(getBrand.fulfilled, (state, action) => {
          state.status = 'succeeded';
          state.brand = action.payload;
          state.loading = false;
        })
        .addCase(getBrand.rejected, (state, action) => {
          state.status = 'failed';
          state.error = action.error.message;
          state.loading = false;
        });
    }
})

export default mainPageSlice.reducer;
export const { reqLoading } = mainPageSlice.actions